import { ScrollReveal } from "../Reveal";

const columns = [
  {
    number: "i.",
    title: "UK Visa Services",
    image: "https://images.unsplash.com/photo-1448906654166-444d494666b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: [
      "Skilled Worker Visa",
      "Standard Visitor Visa",
      "Spouse & Family Visa",
      "Student Visa (Tier 4)",
      "Innovator Founder Visa",
      "Global Talent Visa",
    ],
  },
  {
    number: "ii.",
    title: "Business & Corporate",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: [
      "Sponsor Licence Applications",
      "Work COS applications",
      "Right-to-Work Compliance",
      "Business Visitor Visa",
    ],
  },
  {
    number: "iii.",
    title: "British Citizenship & Settlement",
    image: "https://images.unsplash.com/photo-1454496406107-dc34337da8d6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: [
      "Indefinite Leave to Remain",
      "Naturalisation as British Citizen",
      "British Passport Assistance",
      "Registration for Children",
    ],
  },
];

export default function OurServices() {
  return (
    <section id="services" className="relative bg-navy py-24 md:py-40 border-t border-ivory/10" data-testid="our-services-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <ScrollReveal>
          <h2 className="font-display font-light text-ivory text-5xl md:text-7xl lg:text-8xl leading-none tracking-tight max-w-4xl">
            Our <span className="italic text-gold">Services</span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <p className="mt-8 max-w-xl text-ivory/60 text-base md:text-lg leading-relaxed">
            Every application is prepared by a dedicated consultant, undergoes
            a two&#8209;stage quality review, and is submitted with a
            personalised covering letter. With over 20 years of specialist
            expertise in UK visa services, we ensure every submission meets
            the highest standards of accuracy and care.
          </p>
        </ScrollReveal>

        {/* 3 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-20 mt-20 md:mt-32">
          {columns.map((col, idx) => (
            <ScrollReveal key={col.title} delay={idx * 0.15}>
              <article
                className="group flex flex-col"
                data-testid={`service-col-${idx}`}
              >
                <div className="overflow-hidden mb-8 aspect-[4/5] relative">
                  <img
                    src={col.image}
                    alt=""
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-[1200ms] ease-out group-hover:scale-[1.04]"
                  />
                  <div className="absolute inset-0 border border-ivory/10" />
                </div>
                <div className="border-t border-gold/40 pt-6">
                  <h3 className="font-display text-3xl md:text-4xl text-ivory tracking-tight leading-tight">
                    {col.title}
                  </h3>
                  <ul className="mt-8 space-y-3">
                    {col.items.map((it) => (
                      <li
                        key={it}
                        className="group/item flex items-start gap-4 py-3 border-b border-ivory/10 hover:border-gold transition-colors"
                      >
                        <span className="font-mono-ui text-[10px] text-gold/60 uppercase tracking-widest mt-1 min-w-[24px]">
                          →
                        </span>
                        <span className="text-ivory/85 group-hover/item:text-gold transition-colors">
                          {it}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
